<template>
  <div class="single-page-wrap">
    <div class="parking-pay-wrapper single-page-wrap">
      <div class="plate-list-head" @click="isClickShowColl = !isClickShowColl">
        <!--{{isClickShowColl? '' : '(可点击展开)'}}-->
        <p>车牌号组</p>
        <div style="display: flex">
          <p :class="[isClickShowColl ? 'spin' : 'reset']">
            <i class="iconfont icon-arrow-bottom"></i>
          </p>
        </div>
      </div>
      <transition name="draw">
        <cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions" v-if="isClickShowColl">
          <div class="plate-list-wrapper" v-if="plateList.length > 0">
            <div class="weui-cells-wrapper" v-for="(item, index) of plateList" :key="item.id">
              <button class="weui-btn weui-btn_mini"
                :class="[item.checked == 1 ? 'weui-btn_primary' : 'weui-btn_disabled']"
                @click="handleCheckPlate(item, index)">
                {{ item.plateno }}
              </button>
            </div>
          </div>
          <no-data v-else msg="暂无"></no-data>
        </cube-scroll>
      </transition>
      <p v-if="isShowTips" style="color: #6d6d6d; font-size: 14px; text-align: center; padding-bottom: 5px">
        (灰色代表收费规则已过期，请重新编辑)
      </p>
      <cube-scroll ref="scroll" class="cube-scroll checked-cube-scroll" :options="scrollOptions">
        <div class="checked-plate-list-wrapper">
          <div class="weui-cells-wrapper checked-plate-head-wrapper">
            <span>车牌号</span>
            <span>收费规则</span>
            <span>开始日期</span>
            <span>月数</span>
            <span>操作</span>
          </div>
          <div class="weui-cells-wrapper checked-plate-item-wrapper" :class="val.feescalOverdue === 1 ? 'grey-bg' : ''"
            v-for="(val, key) of checkedPlateObjData" :key="key">
            <span>{{ val.plateno }}</span>
            <span>{{ val.feescalName }}</span>
            <span>{{ val.beginDate || "/" }}</span>
            <span>{{ val.months || "/" }}</span>
            <span @click="handleEdit(val)">编辑</span>
          </div>
        </div>
      </cube-scroll>

      <article class="weui-article">
        <section>
          <div
            class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after weui-cell_park">
            <div class="weui-cell__hd"><label class="weui-label">停车场</label></div>
            <div class="weui-cell__bd">{{ checkedParkName }}</div>
          </div>
        </section>
      </article>
      <div class="weui-form-preview__hd">
        <div class="weui-form-preview__item">
          <label class="weui-form-preview__label">付款金额</label>
          <em class="weui-form-preview__value">¥{{ payMoney }}</em>
        </div>
      </div>
      <div class="weui-btn-area">
        <button class="weui-btn" :class="isDisabled || carTotal <= 0 ? 'weui-btn_disabled' : 'weui-btn_primary'"
          :disabled="isDisabled || carTotal <= 0" @click="handlePay">
          确认缴费
        </button>
      </div>

      <div class="js_dialog" v-show="open">
        <div class="weui-mask"></div>
        <div class="weui-dialog" style="top: 30%; padding: 10px">
          <div class="weui-dialog__hd">
            <strong class="weui-dialog__title">{{ form.plateName }}</strong>
          </div>
          <article class="weui-article">
            <section>
              <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                <div class="weui-cell__hd">
                  <label class="weui-label">收费规则</label>
                </div>
                <div class="weui-cell__bd" @click="handleFeescaleOption">
                  {{ form.feescalName }}
                </div>
              </div>
            </section>
          </article>
          <article class="weui-article">
            <section>
              <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                <div class="weui-cell__hd">
                  <label class="weui-label">开始日期</label>
                </div>
                <div class="weui-cell__bd" @click="handleDateOption">
                  {{ form.startDate }}
                </div>
              </div>
            </section>
          </article>
          <article class="weui-article">
            <section>
              <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                <div class="weui-cell__hd">
                  <label class="weui-label">缴费月数</label>
                </div>
                <div class="weui-cell__bd" @click="handleMonthOption">
                  {{ form.months }}
                </div>
              </div>
            </section>
          </article>
          <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_default" @click="open = false">取消</a>
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click="confirm">确定</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { selectBussinessParkinglot } from "../../../../api/coupon/merChantParkingFee";
import {
  getFeescalFixation,
  getBusinessPlateinfoList,
  payParkingFee,
} from "../../../../api/coupon/parkingFeetoPay";
import { pay } from "../../../../api/coupon/platePay";
import { mapGetters } from "vuex";

export default {
  name: "index",
  data() {
    return {
      plateinfoId: "",
      dateCount: 0,
      monthCount: 0,
      feescaleCount: 0,
      open: false,
      isShowTips: false,
      currentDate: undefined,
      id: undefined,
      form: {
        feescalId: undefined,
        months: undefined,
        monthAmount: undefined,
        feescalName: undefined,
        startDate: undefined,
        plateName: undefined,
      },
      feescaleObj: {},
      checkedPlateObjData: {},
      carTotal: 0,
      isClickShowColl: true,
      scrollOptions: {
        click: true,
        bounce: false,
      },
      plateList: [],
      checkedPlateName: undefined,
      checkedParkId: undefined,
      checkedParkName: undefined,

      minMonthCount: undefined,
      monthAmount: undefined,
      checkedMonthOptions: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
        { label: 4, value: 4 },
        { label: 5, value: 5 },
        { label: 6, value: 6 },
        { label: 7, value: 7 },
        { label: 8, value: 8 },
        { label: 9, value: 9 },
        { label: 10, value: 10 },
        { label: 11, value: 11 },
        { label: 12, value: 12 },
      ],
      parkList: [],
      feeMoney: undefined,
      payMoney: 0,
      isDisabled: false,
      feescaleList: [],
    };
  },
  computed: {
    ...mapGetters(["userOpenid", "userPhone", "businessIds"]),
  },
  created() {
    this.currentDate =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      new Date().getDate().toString().padStart(2, "0");
  },
  mounted() {
    this.getBussinessParkinglot();
  },
  methods: {
    /** 获取商户所属停车场*/
    getBussinessParkinglot() {
      selectBussinessParkinglot(this.userPhone).then((res) => {
        if (res.code === 200) {
          let checkedParkOptions = res.data;
          if (checkedParkOptions.length > 0) {
            checkedParkOptions.map((item) => {
              item.label = item.parkName;
            });
            console.log(checkedParkOptions[0].id, " checkedParkOptions[0].id");
            this.checkedParkId = checkedParkOptions[0].id;
            this.checkedParkName = checkedParkOptions[0].parkName;
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
          this.parkList = checkedParkOptions;
          console.log(this.parkList, "parkList");
          this.getBusinessPlateinfoList();
          // this.getFeescalFixation();
        }
      });
    },
    getBusinessPlateinfoList() {
      console.log(this.businessIds, "this.businessIds");
      getBusinessPlateinfoList({ businessId: this.businessIds[0] }).then(res => {
        // getBusinessPlateinfoList({ businessId: "100651" }).then((res) => {
        if (res.code === 200) {
          let plateList = res.data;
          console.log(plateList[0].id, "plateList");

          plateList.map((item) => {
            if (item.checked == 1) {
              //之前买过的
              this.carTotal++;
              if (item.overdue === 1) {
                //此条记录的开始时间过期
                this.$set(item, "beginDate", this.currentDate);
              } else {
                this.$set(item, "beginDate", item.endDate.slice(0, 10));
              }
              this.checkedPlateObjData[item.id] = item;
            }

            if (item.feescalOverdue === 1) {
              this.isDisabled = true;
              this.isShowTips = true;
            }
          });
          this.calculationAmount();
          this.plateList = res.data;
          if (this.isClickShowColl) {
            this.$nextTick(() => {
              this.$refs.scroll.refresh();
            });
          }
        }
      });
    },
    getFeescalFixation(item) {
      console.log(this.plateinfoId, "plateinfoId");

      getFeescalFixation({ parkinglotId: item.parkinglotId, plateinfoId: item.id }).then(
        (res) => {
          // getFeescalFixation({parkinglotId: this.checkedParkId,plateinfoId:this.plateinfoId }).then(res => {
          if (res.code === 200) {
            let feescaleList = res.data;
            feescaleList.map((item) => {
              this.$set(item, "label", item.feescalName);
              this.$set(item, "value", item.id);
              this.feescaleObj[item.id] = item;
            });
            this.feescaleList = feescaleList;

            if (item.checked) {
              //已选中的取消选中
              item.checked = null;
              delete this.checkedPlateObjData[item.id];
              this.carTotal--;
              this.calculationAmount();
            } else {
              //未选中的去选中

              this.$set(item, "checked", 1);

              item.feescalId = this.feescaleList[0].id;
              item.feescalName = this.feescaleList[0].feescalName;
              item.months = this.feescaleList[0].minMonthCount;
              item.monthAmount = this.feescaleList[0].monthAmount;
              item.feescalOverdue = 0;
              if (item.overdue === 1) {
                //此条记录的开始时间过期
                this.$set(item, "beginDate", this.currentDate);
              } else {
                this.$set(item, "beginDate", item.endDate.slice(0, 10));
              }
              this.checkedPlateObjData[item.id] = item;
              this.carTotal++;
              this.calculationAmount();
            }

            // this.getBusinessPlateinfoList();
          }
        }
      );
    },
    handleCheckPlate(item) {
      this.getFeescalFixation(item);
      // this.plateinfoId = item.id
      console.log(item, "item");
      // if (item.checked) {//已选中的取消选中
      //     item.checked = null;
      //     delete this.checkedPlateObjData[item.id];
      //     this.carTotal--;
      //     this.calculationAmount()
      // } else {//未选中的去选中

      //     this.$set(item, 'checked', 1);

      // 	item.feescalId = this.feescaleList[0].id;
      //     item.feescalName = this.feescaleList[0].feescalName;
      //     item.months = this.feescaleList[0].minMonthCount;
      //     item.monthAmount = this.feescaleList[0].monthAmount;
      //     item.feescalOverdue = 0;
      //     if (item.overdue === 1){//此条记录的开始时间过期
      //         this.$set(item,'beginDate',this.currentDate);
      //     }else {
      //         this.$set(item,'beginDate',item.endDate.slice(0,10));
      //     }
      //     this.checkedPlateObjData[item.id] = item;
      //     this.carTotal++;
      //     this.calculationAmount()
      // }
    },
    /*点击编辑按钮操作**/
    handleEdit(val) {
      console.log(val);
      this.open = true;
      this.id = val.id;
      this.form = {
        startDate: this.checkedPlateObjData[val.id].beginDate,
        plateName: this.checkedPlateObjData[val.id].plateno,
      };
      if (this.checkedPlateObjData[val.id].feescalOverdue === 1) {
        //过期
        this.form.feescalId = this.feescaleList[0].id;
        this.form.feescalName = this.feescaleList[0].feescalName;
        this.form.months = this.feescaleList[0].minMonthCount;
        this.form.monthAmount = this.feescaleList[0].monthAmount;
      } else {
        this.form.feescalId = this.checkedPlateObjData[val.id].feescalId;
        this.form.feescalName = this.checkedPlateObjData[val.id].feescalName;
        this.form.months = this.checkedPlateObjData[val.id].months;
        this.form.monthAmount = this.checkedPlateObjData[val.id].monthAmount;
      }
      this.checkedMonthOptions.map((item) => {
        if (item.value < parseInt(this.feescaleObj[this.form.feescalId].minMonthCount)) {
          this.$set(item, "disabled", true);
        } else {
          this.$set(item, "disabled", false);
        }
      });
    },
    /*点击编辑弹窗确定按钮操作**/
    confirm() {
      this.open = false;
      this.checkedPlateObjData[this.id].feescalOverdue = 0;
      this.checkedPlateObjData[this.id].feescalId = this.form.feescalId;
      this.checkedPlateObjData[this.id].feescalName = this.form.feescalName;
      this.checkedPlateObjData[this.id].months = this.form.months;
      this.checkedPlateObjData[this.id].monthAmount = this.form.monthAmount;
      this.checkedPlateObjData[this.id].beginDate = this.form.startDate;
      Object.keys(this.checkedPlateObjData).map((item) => {
        if (this.checkedPlateObjData[item].feescalOverdue === 1) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      });
      this.calculationAmount();
    },
    /**点击收费规则选项*/
    handleFeescaleOption() {
      this.feescaleCount++;
      this.$weui.picker(this.feescaleList, {
        onConfirm: (result) => {
          this.form.feescalId = result[0].id;
          this.form.feescalName = result[0].feescalName;
          this.form.months = result[0].minMonthCount;
          this.form.monthAmount = result[0].monthAmount;
          this.checkedMonthOptions.map((item) => {
            if (item.value < parseInt(result[0].minMonthCount)) {
              this.$set(item, "disabled", true);
            } else {
              this.$set(item, "disabled", false);
            }
          });
          this.$forceUpdate();
        },
        id: this.feescaleCount,
        defaultValue: [parseInt(this.form.feescalId)],
        title: "收费规则",
      });
    },
    /**点击开始时间选项*/
    handleDateOption() {
      if (this.checkedPlateObjData[this.id].overdue === 0) return;
      this.dateCount++;
      let year = parseInt(this.form.startDate.slice(0, 4));
      let month = parseInt(this.form.startDate.slice(5, 7));
      let day = parseInt(this.form.startDate.slice(8, 11));
      console.log(year, month, day, "时间");
      this.$weui.datePicker({
        start: new Date(),
        onConfirm: (result) => {
          console.log(result);
          this.form.startDate =
            result[0].value +
            "-" +
            result[1].value.toString().padStart(2, "0") +
            "-" +
            result[2].value.toString().padStart(2, "0");
          this.$forceUpdate();
        },
        id: this.dateCount,
        defaultValue: [year, month, day],
        title: "开始时间",
      });
    },
    /*点击月数选项**/
    handleMonthOption() {
      this.monthCount++;
      console.log(this.monthCount);
      this.$weui.picker(this.checkedMonthOptions, {
        onConfirm: (result) => {
          console.log(result);
          this.form.months = result[0].value;
          this.$forceUpdate();
        },
        id: this.monthCount,
        defaultValue: [parseInt(this.form.months)],
        title: "缴费月数",
      });
    },
    /**计算总金额*/
    calculationAmount() {
      let checkedPlateList = Object.keys(this.checkedPlateObjData);
      if (checkedPlateList.length > 0) {
        this.payMoney = 0;
        checkedPlateList.map((item) => {
          let money =
            this.checkedPlateObjData[item].months *
            this.checkedPlateObjData[item].monthAmount;
          this.payMoney += money;
        });
        this.payMoney = this.payMoney.toFixed(2);
      } else {
        this.payMoney = 0;
      }
    },
    toPayParkingFee() {
      console.log(this.checkedParkId, 'this.checkedParkId');

      let checkedPlateList = [];
      Object.keys(this.checkedPlateObjData).map((item) => {
        let obj = {
          feescalId: this.checkedPlateObjData[item].feescalId,
          plateinfoId: this.checkedPlateObjData[item].id,
          platenumber: this.checkedPlateObjData[item].plateno,
          startDate: this.checkedPlateObjData[item].overdue === 1 ? this.checkedPlateObjData[item].beginDate + " " + "00:00:00" : this.checkedPlateObjData[item].endDate,
          months: this.checkedPlateObjData[item].months,
          // parkinglotId: this.checkedPlateObjData[item].parkinglotId,
          payFees: this.checkedPlateObjData[item].months * this.checkedPlateObjData[item].monthAmount,
        };
        checkedPlateList.push(obj);
      });
      let form = {
        isBusinessPlatePay: 1,
        parkinglotId: this.checkedParkId,
        pkFeescalFixationBOListString: checkedPlateList,
        openid: localStorage.getItem("userOpenId") || this.userOpenid,
      };
      return payParkingFee(form);
    },
    toPay(orderForm) {
      return pay(orderForm);
    },
    async handlePay() {
      if (this.checkedParkId == '97') {
        this.$weui.alert('莲花广场暂不支持', { title: '提示' })
      } else {
        try {
          let payParkingFee = await this.toPayParkingFee();
          if (payParkingFee.code === 200) {
            let orderForm = {
              totalAmount: this.payMoney,
              parkinglotId: this.checkedParkId,
              payType: 13,
              orderSn: payParkingFee.data.orderSn,
              openId: localStorage.getItem("userOpenId") || this.userOpenid,
            };
            let order = await this.toPay(orderForm);
            if (order.code === 200) {
              this.$pay(order);
            }
          }
        } catch (e) { }
      }

    },
  },
};
</script>

<style scoped lang="stylus">
@import '~common/stylus/variable'
.parking-pay-wrapper {
	padding 20px 0
	.weui-article {
		padding-top 0
		padding-bottom 0
		section {
			margin-bottom 0
		}
		.weui-label {
			width 80px
		}
		.weui-cell_select-after {
			padding-left 0
		}
		.main-plate {
			font-size 14px
		}
		.weui-cell_select-after {
			display flex
			/*justify-content space-between*/
		}
		.weui-cell_park{
			.weui-cell__bd:after{
				width 0
				height: 0;
			}
		}
	}
	.plate-list-head {
		padding 10px 30px 20px 15px
		display flex
		justify-content space-between
		align-items center
		.check-all {
			font-size 14px
			color #6d6d6d
		}
		.icon-arrow-bottom, .icon-arrow-up {
			/*padding 0 15px 0 5px*/
		}
	}
	.order-info {
		font-size 16px
		color #6d6d6d
		padding 10px 0
		display flex
		justify-content space-between
	}
	.weui-btn-area {
		margin-top 30px
		.weui-btn_primary, .weui-btn_disabled {
			width 100%
		}
	}
	.cube-scroll {
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 25%;
		overflow hidden
		/*background: #ffffff;*/
		/*margin-bottom 50px*/
		.no-data-wrap {
			padding-top 25%
			display flex
			justify-content center
			align-items center
			.weui-article {
				color $no-data-font-color
				h1 {
					font-size $no-data-font-size
				}
			}
		}
		.plate-list-wrapper {
			padding 0 20px
			display flex
			flex-wrap wrap
			.weui-cells-wrapper {
				width 31%
				padding 6px 1%
				.weui-btn_mini, .weui-btn_default, .weui-btn_primary {
					font-size 14px
					width 100%
					padding-top 5px
					padding-bottom 5px
				}
			}
		}
		.checked-plate-head-wrapper{
			color #525A6E
			background-color #F8F8F9
			padding 8px 10px
			display flex
			justify-content space-between
			span{
				text-align center
			}
			span:first-child{
				width 25%
				text-align left
			}
			span:nth-child(2){
				width 25%
			}
			span:nth-child(3){
				width 30%
			}
			span:nth-child(4){
				width 10%
			}
			span:last-child{
				width 10%
				text-align right
			}
		}
		.checked-plate-list-wrapper{
			.checked-plate-item-wrapper{
				padding 10px
				display flex
				justify-content space-between
				span{
					color #66686C
					text-align center
				}
				span:first-child{
					width 25%
					text-align left
				}
				span:nth-child(2){
					font-size 14px
					width 25%
					overflow: hidden;
					text-overflow:ellipsis;
					white-space: nowrap;
				}
				span:nth-child(3){
					width 30%
					text-align center
				}
				span:nth-child(4){
					width 10%
					text-align center
				}
				span:last-child{
					width 10%
					padding 0 2px
					color #06ae56
					text-align right
				}

			}
		}
	}
	.weui-form-preview__hd{
		padding-top 8px
		padding-bottom 8px
	}
	.checked-cube-scroll{
		max-height 25%
		border 1px solid #e6e6e6
	}
	.draw-enter-active, .draw-leave-active {
		transition: all .4s ease;
	}
	.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */
	{
		height: 0;
	}
	.reset {
		transition: all 1s
	}
	.spin {
		transform rotate(-180deg)
		transition: all 1s;
	}
	.show{
		visibility visible
	}
	.hidden{
		visibility hidden
	}
	.grey-bg{
		background-color #e6e6e6
	}
}

.no-enter {
	position absolute
	top 0
	left 0
	right 0
	background-color #ffffff
	height 100%
	z-index 9999
	display flex
	justify-content center
	align-items center
	font-size 20px
	p {
		padding-bottom 70px
	}
}
</style>
